<!--
 * @Description: 个人信息-》绑定微信
 * @Version: 2.0
 * @Autor: YGQ
 * @Date: 2023-12-04 15:52:09
 * @LastEditors: YGQ
 * @LastEditTime: 2026-09-18 18:09:01
-->
<template>
  <el-dialog
    title="绑定微信"
    width="480px"
    custom-class="dialog bind-wechat"
    :visible="visible"
    :before-close="() => $emit('hide')"
  >
    <div style="padding: 0 16px 16px; min-height: 370px">
      <!-- 微信登录二维码 -->
      <LoginWeChat
        v-if="visible"
        platform="wechat"
        text1="微信扫码并关注"
        text2="杰姆龙PMS服务号"
        api="getThirdPartyBindCode"
        @ok="onBindSuccess"
      />
    </div>
  </el-dialog>
</template>

<script>
import LoginWeChat from "@/components/LoginWeChat";
export default {
  components: { LoginWeChat },
  props: {
    visible: Boolean,
  },
  methods: {
    // 扫码成功(LoginWeChat 已刷新用户信息, 透传给 user 页更新本地快照)
    onBindSuccess(user) {
      const fresh = user || JSON.parse(localStorage.getItem("user") || "{}");
      fresh.isBindWx = 1;
      localStorage.setItem("user", JSON.stringify(fresh));
      this.$msg.success("绑定成功");
      this.$emit("update", fresh);
      this.$emit("hide");
    },
  },
};
</script>
 
<style >
.dialog {
  border-radius: 8px;
}
</style>
